export default {
      id: "oc-volcengine-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-volcengine",
      toString: function () {
        return this.url;
      }
    }